const getWordPressJquery = async () => {
    const response = await fetch("Auth/GetWordpressJquery");
    const result = await response.text();
    return result;
}

export default getWordPressJquery;